export enum FaqKeys {
  UrlParam = 'faq',
}
